import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";
import InstallPWAButton from "@/components/InstallPWAButton";

export default function Login() {
  const { user, login, error } = useAuth();
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  if (user && user !== false) return <Navigate to="/" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    const ok = await login(identifier, password);
    setSubmitting(false);
    if (ok) navigate("/");
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FCF9F2] px-4 py-8">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img
            src="/splash-logo.png?v=1"
            alt="Darkar Co. Paletas y Helados"
            data-testid="login-logo"
            className="w-52 h-52 sm:w-60 sm:h-60 mx-auto mb-2 object-contain drop-shadow-[0_10px_20px_rgba(247,200,224,0.55)]"
          />
        </div>

        <form
          onSubmit={onSubmit}
          className="bg-white rounded-3xl border border-[#EADBCE] p-6 sm:p-8 shadow-sm space-y-5"
          data-testid="login-form"
        >
          <div className="space-y-2">
            <Label htmlFor="identifier" className="text-sm font-semibold text-[#4A3B32]">Usuario o correo</Label>
            <Input
              id="identifier"
              type="text"
              value={identifier}
              onChange={(e) => setIdentifier(e.target.value)}
              required
              autoComplete="username"
              autoCapitalize="none"
              spellCheck={false}
              placeholder="tu_usuario"
              data-testid="login-email-input"
              className="h-12 rounded-xl border-[#EADBCE] focus:ring-2 focus:ring-[#F7C8E0] focus:border-transparent"
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="password" className="text-sm font-semibold text-[#4A3B32]">Contraseña</Label>
            <Input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
              placeholder="••••••••"
              data-testid="login-password-input"
              className="h-12 rounded-xl border-[#EADBCE] focus:ring-2 focus:ring-[#F7C8E0] focus:border-transparent"
            />
          </div>

          {error && (
            <p className="text-sm text-[#FF5C5C] bg-[#FFF0F0] border border-[#FF7878]/30 rounded-lg px-3 py-2" data-testid="login-error">
              {error}
            </p>
          )}

          <Button
            type="submit"
            disabled={submitting}
            data-testid="login-submit-button"
            className="w-full h-12 rounded-full bg-[#FF7878] hover:bg-[#FF5C5C] text-white font-bold active:scale-95 transition-transform"
          >
            {submitting ? <Loader2 className="w-5 h-5 animate-spin" /> : "Iniciar sesión"}
          </Button>

          <p className="text-xs text-[#8A796F] text-center pt-2">
            ¿No tienes acceso? Pide a tu Gerente que cree tu usuario.
          </p>
        </form>

        <div className="flex justify-center mt-6">
          <InstallPWAButton />
        </div>
      </div>
    </div>
  );
}
